// material-ui
import { useTheme } from '@mui/material/styles';

import { Box } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import Logo from '../../../../../src/assets/images/media/logo.png';
import LogoSmall from '../../../../../src/assets/images/media/logo_small.png';
import { ROUTES } from '../../../../routes/routes';
import { activeNavItem } from '../../../../store/slicers/menu.slicers';
import { RootState } from '../../../../store/store';
import { DrawerHeaderStyled } from './styles';

// ==============================|| DRAWER HEADER ||============================== //
interface DrawerHeaderProps {
  open: boolean;
}

export const DrawerHeader = ({ open }: DrawerHeaderProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { drawerOpen } = useSelector((state: RootState) => state.menu);

  const handleNavigate = () => {
    dispatch(activeNavItem({ openNavItem: '' }));
    navigate(ROUTES.authenticated.dashboard);
  };

  return (
    <DrawerHeaderStyled theme={theme} open={drawerOpen}>
      {!open ? (
        <Link onClick={handleNavigate} to={ROUTES.authenticated.dashboard}>
          <Box sx={{ display: 'flex', height: '72px', p: 1, py: 1.5, backgroundColor: theme.palette.primary.main }}>
            <img src={LogoSmall} alt="logo" width="100%" />
          </Box>
        </Link>
      ) : (
        <Link onClick={handleNavigate} to={ROUTES.authenticated.dashboard}>
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: theme.palette.primary.main
            }}
          >
            <img src={Logo} alt="logo" width="100%" />
          </Box>
        </Link>
      )}
    </DrawerHeaderStyled>
  );
};
